import { OnReady } from "taskpane/models/types";
import { API } from "taskpane/constants/api";
import useQuery from "./useQuery";
import { IQueryResponse } from "taskpane/models/interfaces";
import { encodeUriParams } from "taskpane/utils";

export interface IQueryConfigResponse {
  "api-urls"?: {
    "main-api"?: string;
  };
  "api-version"?: number;
}

const useQueryConfig = (domain: string, onReady: OnReady<IQueryResponse<IQueryConfigResponse>>): void => {
  const url = `${API.url}/myteam-config.json${encodeUriParams({ domain })}`;
  useQuery(url, "GET", onReady);
};

export default useQueryConfig;
